import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import { Button, Card, CardBody, Input } from "reactstrap";
import { getListInvoiceType, getListRootInvoiceTemplate } from "store/actions";
import { AUTH_TOKEN, ROLE_ADMIN } from "store/auth/login/actionTypes";
import { RootInvoiceTemplate } from "./const";

const InvoiceTemplateSelection = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation(["invoiceTemplate"]);
  const [invoiceTypeOptions, setInvoiceTypeOptions] = useState([]);
  const [selectedInvoiceType, setSelectedInvoiceType] = useState(
    invoiceTypeOptions[0]
  );
  const [keyword, setKeyword] = useState("");
  const [isShowCreateButton, setIsShowCreateButton] = useState(false);

  const { listRoot, loadingListRoot } = useSelector(
    state => state.invoiceTemplate
  );
  const { listInvoiceType } = useSelector(state => state.invoiceTemplate);

  const dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = dashboard;

  const handleSelect = item => {
    history.push(`/invoice-templates/create?root-template-id=${item.id}`);
  };

  const handleSearchClick = () => {
    listRoot.params = {
      ...listRoot.params,
      page: 1,
      sizePerPage: 10,
      keyword,
    };

    listRoot.params.columnFilter = {
      ...listRoot.params.columnFilter,
      "filter[khmhdon]":
        selectedInvoiceType && selectedInvoiceType.value
          ? selectedInvoiceType.value.ttchung_khmshdon
          : null,
    };

    dispatch(getListRootInvoiceTemplate(listRoot.params));
  };

  useEffect(() => {
    listRoot.params = {
      page: 1,
      sizePerPage: 10,
    };
    listRoot.params.columnFilter = {
      "filter[record_status]": "O",
      "filter[type]": RootInvoiceTemplate,
      "filter[khmhdon]":
        selectedInvoiceType && selectedInvoiceType.value
          ? selectedInvoiceType.value.ttchung_khmshdon
          : null,
    };

    dispatch(getListRootInvoiceTemplate(listRoot.params));
  }, []);

  useEffect(() => {
    if (finalBuInfo?.id) {
      dispatch(getListInvoiceType(finalBuInfo.id));
    }
  }, [finalBuInfo]);

  useEffect(() => {
    if (listInvoiceType) {
      const options = [
        {
          value: null,
          label: "Tất cả",
        },
        ...listInvoiceType.map(item => ({
          value: item,
          label: item.name,
        })),
      ];

      setInvoiceTypeOptions(options);
    }
  }, [listInvoiceType]);

  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser && roleUser === ROLE_ADMIN) {
      setIsShowCreateButton(true);
    } else {
      setIsShowCreateButton(false);
    }
  }, []);

  return (
    <div className="page-content invoice-template-selection">
      <MetaTags>
        <title>{t("templateSelection.title")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={t("templateSelection.title")}
          breadcrumbItems={[
            { name: t("list.title.pageTitle"), link: "/invoice-templates" },
          ]}
        />

        <Card>
          <CardBody>
            <div className="row mb-4">
              <div className="col-xl-3 col-lg-4 col-md-5">
                <label>Loại hóa đơn</label>
                <Select
                  value={selectedInvoiceType}
                  onChange={event => {
                    setSelectedInvoiceType(event);
                  }}
                  placeholder="Chọn loại hóa đơn"
                  options={invoiceTypeOptions}
                  classNamePrefix="select2-selection"
                />
              </div>
              <div className="col-xl-3 col-lg-4 col-md-5 mt-3 mt-md-0">
                <label>Từ khóa</label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Từ khóa"
                  value={keyword}
                  onChange={event => {
                    setKeyword(event.target.value);
                  }}
                />
              </div>
              <div className="col-xl-6 col-lg-4">
                <label>&nbsp;</label>
                <div className="d-flex justify-content-between">
                  <Button
                    onClick={handleSearchClick}
                    color="primary"
                    outline
                    className="me-2"
                  >
                    {t("common:search")}
                  </Button>

                  {isShowCreateButton && (
                    <Link
                      to={`/invoice-templates/create?create-root-template=true`}
                      className="btn btn-success ms-3"
                    >
                      Tạo mẫu hóa đơn gốc
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              {listRoot.items?.length > 0 ? (
                <>
                  {listRoot.items.map(item => (
                    <div
                      key={item.id}
                      className="col-xl-4 col-lg-6 mb-4"
                      onClick={() => handleSelect(item)}
                    >
                      <div className="border border-primary border-2 card rounded template-item">
                        <img
                          className="img-fluid"
                          src={
                            item.config.rootTemplateThumbnail ||
                            "/mau-hoa-don/01.png"
                          }
                        />
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {loadingListRoot ? (
                    <div className="d-flex flex-column w-100 align-items-center mt-5">
                      <div
                        className="spinner-border text-primary"
                        style={{ width: "3rem", height: "3rem" }}
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <div className="mt-3">Đang tải</div>
                    </div>
                  ) : (
                    <div className="my-5 d-flex flex-column align-items-center justify-content-center">
                      Không có dữ liệu
                    </div>
                  )}
                </>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default InvoiceTemplateSelection;
